(function () {
  'use strict';

  angular.module('wsLrs.services').factory('AppPermissions', ['$http', '$q', 'Api', 'Groups', 'Logger', 'People', 'Resource', 'User', 'Utils', '$rootScope', function ($http, $q, Api, Groups, Logger, People, Resource, User, Utils, $rootScope) {
    $rootScope.$on('organization-selected', function () {
      permissionsByType = {};
    });
    var permissionsByType = {};
    var baseResource = new Resource("/app-permissions", false);
    var self = _.extend(baseResource, {
      __permissions_for_user: null,
      getForUser: function getForUser(cfg) {
        cfg = cfg || {};
        var userId = cfg.userId || User.get().user && User.get().user.id,
          url = Utils.appendParams(Api.url("/app-permissions/users/" + userId), {
            value: cfg.value
          });
        if (!self.__permissions_for_user) {
          self.__permissions_for_user = $http.get(url).then(function (response) {
            return response.data.results;
          });
        }
        return self.__permissions_for_user;
      },
      getPermissions: function getExpandedPermissions(value) {
        var allPeopleIds = [],
          allPeople = [],
          allGroupIds = [],
          allGroups = [];
        function newDecoratedPermission() {
          return {
            permissions: [],
            people: [],
            groups: []
          };
        }
        if (!_.isEmpty(permissionsByType)) {
          var def = $q.defer();

          // if value not specified, return all permissions
          if (_.isUndefined(value) || value === null) {
            def.resolve(permissionsByType);

            // else return permissions for specified value
          } else {
            if (_.has(permissionsByType, value)) {
              def.resolve(permissionsByType[value]);
            } else {
              def.resolve(newDecoratedPermission());
            }
          }
          return def.promise;
        }

        // get all appPermissions, cache by value (explorer, dashboard, etc)
        return baseResource.getAll({
          maxLimit: 10000
        }).then(function (permissions) {
          _.each(permissions, function (permission) {
            // if permission.value == 'explorer', use entityId = 'explorer'
            var entityId = null;
            if (permission.value === 'explorer') {
              entityId = 'explorer';
            } else {
              entityId = permission.entityId;
            }

            // create/add permissionsByEntityId map for each permission.value
            if (!_.has(permissionsByType, permission.value)) {
              permissionsByType[permission.value] = {};
            }
            var permissionsByEntityId = permissionsByType[permission.value];

            // create/add permission object for each entityId
            var entityPermission = null;
            if (!_.has(permissionsByEntityId, entityId)) {
              entityPermission = newDecoratedPermission();
              entityPermission.peopleIds = [];
              entityPermission.groupIds = [];
              permissionsByEntityId[entityId] = entityPermission;
            }
            entityPermission = permissionsByEntityId[entityId];

            // save permission info for entity, collect person/group ids for object association
            entityPermission.permissions.push(permission);
            if (permission.personId) {
              entityPermission.people.push(permission.person);
              entityPermission.peopleIds.push(permission.personId);
              allPeople.push(permission.person);
              allPeopleIds.push(permission.personId);
            } else if (permission.groupId) {
              entityPermission.groups.push(permission.group);
              entityPermission.groupIds.push(permission.groupId);
              allGroups.push(permission.group);
              allGroupIds.push(permission.groupId);
            }
          });

          // if permission type not specified, return all permissions
          if (_.isUndefined(value) || value === null) {
            return permissionsByType;
          }

          // else return permissions of specified type
          if (_.has(permissionsByType, value)) {
            return permissionsByType[value];
          }

          // else return empty permissions map
          var result = {};
          result[value] = newDecoratedPermission();
          return result;
        });
      }
    });

    // Any tenant bound API urls must be reset when the org changes
    $rootScope.$on('organization-selected', function () {
      self.__permissions_for_user = null;
    });
    return self;
  }]);
})();
